module.exports = ".suggestions{\r\n    background-color:#f4f4f4;\r\n    position:absolute;\r\n    z-index: 3;\r\nwidth:83%\r\n}\r\n.filter-input{\r\n    width: 168px\r\n}\r\n.none li{\r\n   list-style-type: none;\r\n}\r\nul{\r\n    padding-left: 10px!important;\r\n}\r\n.suggestions-mbl{\r\n    background-color:#f4f4f4;\r\n    position:absolute;\r\n    z-index: 3;\r\nwidth:91%\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/activity-log/auto-complete/auto-complete.css
// module id = ./src/app/modules/activity-log/auto-complete/auto-complete.css
// module chunks = main